var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_71681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 20C1.66699 24.8623 3.59853 29.5255 7.0367 32.9636C10.4749 36.4018 15.138 38.3334 20.0003 38.3334C24.8626 38.3334 29.5258 36.4018 32.964 32.9636C36.4021 29.5255 38.3337 24.8623 38.3337 20C38.3337 15.1377 36.4021 10.4746 32.964 7.0364C29.5258 3.59823 24.8626 1.66669 20.0003 1.66669C15.138 1.66669 10.4749 3.59823 7.0367 7.0364C3.59853 10.4746 1.66699 15.1377 1.66699 20Z",
    fill: "var(--svg-secondary-color, #FAFBFF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.49995C24.3542 7.50264 28.5649 9.05559 31.8779 11.8806C35.1909 14.7055 37.3897 18.6179 38.0803 22.9166C38.4858 20.4179 38.3693 17.8624 37.738 15.411C37.1067 12.9596 35.9743 10.6656 34.4124 8.6736C32.8504 6.68161 30.8926 5.03484 28.6625 3.83711C26.4325 2.63939 23.9784 1.91668 21.4551 1.71457C18.9318 1.51246 16.394 1.83532 14.0017 2.6628C11.6094 3.49028 9.41452 4.80442 7.55538 6.52238C5.69623 8.24035 4.21318 10.3249 3.19972 12.6445C2.18627 14.9641 1.66439 17.4686 1.667 20C1.67417 20.9773 1.75888 21.9526 1.92034 22.9166C2.611 18.6179 4.80981 14.7055 8.1228 11.8806C11.4358 9.05559 15.6465 7.50264 20.0003 7.49995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 20C1.66699 24.8623 3.59853 29.5255 7.0367 32.9636C10.4749 36.4018 15.138 38.3334 20.0003 38.3334C24.8626 38.3334 29.5258 36.4018 32.964 32.9636C36.4021 29.5255 38.3337 24.8623 38.3337 20C38.3337 15.1377 36.4021 10.4746 32.964 7.0364C29.5258 3.59823 24.8626 1.66669 20.0003 1.66669C15.138 1.66669 10.4749 3.59823 7.0367 7.0364C3.59853 10.4746 1.66699 15.1377 1.66699 20Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.167 28.3333H21.667C21.225 28.3333 20.801 28.1577 20.4885 27.8452C20.1759 27.5326 20.0003 27.1087 20.0003 26.6667V15.8333C20.0003 15.6123 19.9125 15.4004 19.7562 15.2441C19.6 15.0878 19.388 15 19.167 15H16.667",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5749 10.8333C19.4925 10.8333 19.4119 10.8577 19.3434 10.9035C19.2749 10.9493 19.2215 11.0144 19.1899 11.0905C19.1584 11.1667 19.1501 11.2504 19.1662 11.3313C19.1823 11.4121 19.222 11.4863 19.2802 11.5446C19.3385 11.6029 19.4128 11.6426 19.4936 11.6586C19.5744 11.6747 19.6582 11.6665 19.7343 11.6349C19.8105 11.6034 19.8755 11.55 19.9213 11.4815C19.9671 11.4129 19.9915 11.3324 19.9915 11.25C19.9915 11.1395 19.9476 11.0335 19.8695 10.9554C19.7914 10.8772 19.6854 10.8333 19.5749 10.8333Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_71681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.f939eb98c12d7ffc3607ed1957345d64.svg";
export { ForwardRef as ReactComponent };